import { render } from "./DoubleBarChart.vue?vue&type=template&id=4738b10c&scoped=true"
import script from "./DoubleBarChart.vue?vue&type=script&lang=js"
export * from "./DoubleBarChart.vue?vue&type=script&lang=js"

import "./DoubleBarChart.vue?vue&type=style&index=0&id=4738b10c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4738b10c"]])

export default __exports__